// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPriceStyles } from "@stoneage/Overrides/Components/ProductPrice";
import { fontConfig } from "@stoneage/XDL/constants";
import { css } from "styled-components";

productPriceStyles.price = {
    configurableProductPricePrefix: {
        ...fontConfig.xSmallSingleLine,
        css: css`
            display: block;
            margin-bottom: 4px;
        `,
    },
    priceText: {
        variant: "h4",
        css: css`
            display: inline-block;
            margin-bottom: 0;
        `,
    },
    unitOfMeasure: {
        unitOfMeasureText: {
            variant: "h4",
            weight: fontConfig.weight.regular,
            css: css`
                display: inline-block;
                margin-bottom: 0;
            `,
        },
    },
};
